export const addUserInterface = {
    idCompromisoUnico: '',
    idUsuario: '',
    idPerfil: '',
    idAmbitoCargo: '',
    AmbitoValorCargo: '',
}